import './App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import ServicesTimeline from './components/ServicesTimeline';
import CertifiedPartners from './components/CertifiedPartners';
import About from './components/About';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import WhatsAppFloating from './components/WhatsAppFloating';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <Hero />
        <ValueProposition />
        <ServicesTimeline />
        <CertifiedPartners />
        <About />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
}

export default App;
